import { Navigation } from '../../Navigation';
import * as React from 'react';
import style from './Sitemap.less';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';

interface SitemapProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
}

interface SitemapState extends React.ClassAttributes<any> {
    navigation: any[];
}

export class Sitemap extends React.Component<SitemapProps, SitemapState> {

    constructor(props: any) {
        super(props);
        this.state = {
            navigation: null
        };
    }

    componentDidMount(): void {
        this.init();
    }

    init(): void {
        (new Navigation(this.props.data)).getData((navigation: any) => {
            this.setState({ navigation });
        });
    }

    render(): JSX.Element {
//        if (this.state.navigation === null) {
//            return <>Lade...</>;
//        }

        return (
            <div className={style.wrapper}>
                <div>
                    {this.renderGroup(this.state.navigation, 0)}
                </div>
                {this.state.navigation === null && <WSpinner />}
            </div>
        );
    }

    renderChildren(item: any, level: number): JSX.Element {
        return (
            <div
                className={style[`level-${level}`]}
                style={{
                    color: item.color && item.color, backgroundColor: item.bgcolor && item.bgcolor, cursor: item.path && 'pointer',
                    paddingLeft: level * 20 + 10
                }}
                onClick={() => this.props.onRoutingChange({ path: item.path || {} })}
            >
                {item.name}
            </div>
        );
    }

    renderGroup(data: any[], level: number): JSX.Element[] {
        return (data || []).map((item: any, index: number) => {
            if (item.disabled || false) {
                return null;
            }
            const children: any[] = item.children || [];

            if (level === 0) {
                return (
                    <div
                        key={`group-${index}`}
                        style={{ color: item.color && item.color, backgroundColor: item.bgcolor && item.bgcolor }}
                    >
                        {this.renderChildren(item, level)}
                        {!!children.length && this.renderGroup(children, level + 1)}
                    </div>
                );
            }

            return (
                <React.Fragment key={`site-${level}-${index}`}>
                    {this.renderChildren(item, level)}
                    {!!children.length && this.renderGroup(children, level + 1)}
                </React.Fragment>
            );
        });
    }
}
